<jhi-bary-button class="btn btn-primary m-0" (clickEvent)="showModal()" icon="search" [label]="'LABEL.SEARCH' | translate"></jhi-bary-button>
<div class="d-block mt-3" *ngIf="options">
  <jhi-filter-button *ngFor="let optionButton of options" [attributeFilter]="optionButton" (buttonRemoved)="removeFilter(optionButton)"></jhi-filter-button>
</div>
